import { Link } from 'react-router-dom';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

function trackForSale(source: string) {
  if (window.gtag) {
    window.gtag('event', 'for_sale_click', { source });
  }
}

export default function ForSaleHeroBanner() {
  return (
    <div className="w-full bg-[#DC2626]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="flex items-center gap-3 flex-wrap justify-center sm:justify-start">
          <span className="text-white text-lg font-black tracking-wide whitespace-nowrap">
            🚨 THIS WEBSITE IS FOR SALE
          </span>
          <span className="text-red-200 text-sm hidden md:block whitespace-nowrap">
            Acquire this turnkey SEO &amp; lead generation asset
          </span>
        </div>
        <Link
          to="/for-sale"
          onClick={() => trackForSale('hero_banner')}
          className="flex-shrink-0 bg-white text-[#DC2626] text-sm font-bold px-5 py-2 rounded-lg hover:bg-red-50 transition-colors whitespace-nowrap cursor-pointer"
        >
          VIEW DETAILS &rarr;
        </Link>
      </div>
    </div>
  );
}
